/* global-coupons.js
   Renders #GlobalCouponData (sections/global-coupon-manager.liquid) into the
   PDP and cart-drawer containers.
   PDP:  data-pdp-handle, data-pdp-price, data-pdp-collections (csv)
   Cart: data-gc-cart-total, data-gc-cart-items (JSON) */
(function () {
  "use strict";

  if (window.__globalCouponsInit) return;
  window.__globalCouponsInit = true;

  var DISCOUNT_KEY = "active_shopify_discount";

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function csv(v) {
    return String(v == null ? "" : v)
      .split(",")
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[m];
    });
  }

  function formatRupees(n) {
    var v = Math.round(Number(n) || 0);
    return "Rs. " + v.toLocaleString("en-IN");
  }

  function parseRupees(val) {
    var n = parseFloat(val) || 0;
    if (n >= 100000) {
      return Math.round(n / 100);
    }
    return Math.round(n);
  }

  function parseCurrencyString(str) {
    if (!str) return 0;
    var clean = String(str)
      .replace(/Rs\.?|₹/gi, "")
      .replace(/,/g, "")
      .trim();
    var match = clean.match(/[\d]+(?:\.\d+)?/);
    return match ? parseFloat(match[0]) : 0;
  }

  function getCartSubtotalInRupees() {
    if (window.cart) {
      if (typeof window.cart.original_total_price === "number") {
        return Math.round(window.cart.original_total_price / 100);
      }
      if (typeof window.cart.total_price === "number") {
        return Math.round(window.cart.total_price / 100);
      }
    }
    var subtotalEl = document.querySelector("[data-cart-subtotal]");
    if (subtotalEl && subtotalEl.textContent) {
      var parsed = parseCurrencyString(subtotalEl.textContent);
      if (!isNaN(parsed) && parsed > 0) {
        return Math.round(parsed);
      }
    }
    var target = document.querySelector('[data-global-coupons-target="cart"]');
    if (target) {
      if (target.hasAttribute("data-gc-cart-total-rupees")) {
        return Math.round(
          parseFloat(target.getAttribute("data-gc-cart-total-rupees")) || 0,
        );
      }
      var raw = parseFloat(target.getAttribute("data-gc-cart-total")) || 0;
      return Math.round(raw / 100);
    }
    return 0;
  }

  function getProductPriceInRupees(root) {
    if (root.hasAttribute("data-pdp-price-rupees")) {
      return Math.round(
        parseFloat(root.getAttribute("data-pdp-price-rupees")) || 0,
      );
    }
    var raw = parseFloat(root.getAttribute("data-pdp-price")) || 0;
    return Math.round(raw / 100);
  }

  /* Eligibility + min-purchase */

  function eligibleFor(c, ctx) {
    var elig = c.eligibility || "all";
    if (elig === "all") return true;

    if (elig === "collection") {
      var tcol =
        (typeof c.target_collection === "object" && c.target_collection
          ? c.target_collection.handle
          : c.target_collection) || "";
      if (!tcol) return true;
      if (ctx.kind === "product") return ctx.collections.indexOf(tcol) !== -1;
      for (var i = 0; i < ctx.items.length; i++) {
        if (csv(ctx.items[i].collections).indexOf(tcol) !== -1) return true;
      }
      return false;
    }

    if (elig === "product") {
      var tprod =
        (typeof c.target_product === "object" && c.target_product
          ? c.target_product.handle
          : c.target_product) || "";
      if (!tprod) return true;
      if (ctx.kind === "product") return ctx.handle === tprod;
      for (var j = 0; j < ctx.items.length; j++) {
        if (ctx.items[j].handle === tprod) return true;
      }
      return false;
    }
    return false;
  }

  function minOk(c, ctx) {
    if (ctx && ctx.kind === "product") return true;
    var min = parseRupees(c.min_purchase);
    if (min <= 0) return true;
    var current = Math.round(Number(ctx.price) || 0);
    return current >= min;
  }

  function passes(c, ctx) {
    return (
      !!c.active &&
      !!c.code &&
      !!c.title &&
      eligibleFor(c, ctx) &&
      minOk(c, ctx)
    );
  }

  /* PDP renderer (simplified) */

  function renderPdp(root, coupons) {
    var ctx = {
      kind: "product",
      handle: root.getAttribute("data-pdp-handle") || "",
      price: getProductPriceInRupees(root),
      collections: csv(root.getAttribute("data-pdp-collections")),
    };

    var visible = [];
    for (var i = 0; i < coupons.length; i++) {
      if (passes(coupons[i], ctx)) visible.push(coupons[i]);
    }

    if (visible.length === 0) {
      root.innerHTML = "";
      return;
    }

    if (visible.length === 1) {
      var c0 = visible[0];
      var terms0 = c0.code ? ' <span class="offerline__terms">Use code ' + escapeHtml(c0.code) + '</span>' : '';
      root.innerHTML =
        '<div class="offerline" id="offer">' +
        '<span class="offerline__tag">Offer</span>' +
        '<span><b>' + escapeHtml(c0.title) + '</b>' + terms0 + '</span>' +
        '</div>';
      return;
    }

    var subsequentRows = "";
    for (var k = 1; k < visible.length; k++) {
      var ck = visible[k];
      var termsK = ck.code ? ' <span class="offerline__terms">Use code ' + escapeHtml(ck.code) + '</span>' : '';
      subsequentRows +=
        '<div style="padding-top:6px;margin-top:6px;border-top:1px dashed var(--line, #E8DFD3);">' +
        '<b>' + escapeHtml(ck.title) + '</b>' + termsK +
        '</div>';
    }

    var cFirst = visible[0];
    var termsFirst = cFirst.code ? ' <span class="offerline__terms">Use code ' + escapeHtml(cFirst.code) + '</span>' : '';

    root.innerHTML =
      '<style>' +
      '.offerline summary::-webkit-details-marker { display: none; }' +
      '.offerline summary { list-style: none; }' +
      '.offerline summary::marker { display: none; }' +
      '.offerline[open] .offerline__chevron { transform: rotate(180deg); }' +
      '</style>' +
      '<details class="offerline" id="offer">' +
      '<summary style="display:flex;align-items:center;justify-content:space-between;cursor:pointer;list-style:none;outline:none;">' +
      '<div style="display:grid;gap:2px;flex:1 1 auto;min-width:0;">' +
      '<span class="offerline__tag">Offer</span>' +
      '<span><b>' + escapeHtml(cFirst.title) + '</b>' + termsFirst + '</span>' +
      '</div>' +
      '<svg class="offerline__chevron" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-left:8px;transition:transform 0.2s ease;">' +
      '<polyline points="6 9 12 15 18 9"/>' +
      '</svg>' +
      '</summary>' +
      '<div class="offerline__body" style="margin-top:6px;">' +
      subsequentRows +
      '</div>' +
      '</details>';
  }

  /* State & Checkout Synchronization */
  var isCouponApplied = false;
  var appliedCouponCode = "";
  var appliedCouponObj = null;
  var _cachedCoupons = [];
  var _cachedCartItems = [];

  // Purge any stale storage keys on initialization to prevent coupon from auto-applying
  try {
    sessionStorage.removeItem("applied_gc_coupon");
    sessionStorage.removeItem("active_shopify_discount");
    localStorage.removeItem("applied_gc_coupon");
    localStorage.removeItem("active_shopify_discount");
  } catch (e) {}

  function getAppliedCouponCode() {
    return isCouponApplied ? (appliedCouponCode || "").trim() : "";
  }

  function setAppliedCouponCode(code) {
    var clean = (code || "").trim();
    if (clean) {
      isCouponApplied = true;
      appliedCouponCode = clean;
    } else {
      isCouponApplied = false;
      appliedCouponCode = "";
      appliedCouponObj = null;
      try {
        sessionStorage.removeItem("applied_gc_coupon");
        sessionStorage.removeItem("active_shopify_discount");
      } catch (e) {}
    }
  }

  function syncCheckoutWithDiscount(code) {
    var cleanCode = isCouponApplied ? (code || "").trim() : "";

    $$('a[href*="/checkout"], [data-cart-checkout]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (cleanCode) {
          url.searchParams.set("discount", cleanCode);
        } else {
          url.searchParams.delete("discount");
        }
        link.href = url.pathname + url.search + url.hash;
      } catch (e) {
        link.href = cleanCode
          ? "/checkout?discount=" + encodeURIComponent(cleanCode)
          : "/checkout";
      }
    });

    // Cart forms, strictly excluding add-to-cart forms
    $$(
      'form[action="/cart"], form[action*="/cart"]:not([action*="/cart/add"])',
    ).forEach(function (form) {
      try {
        var currentAct = form.getAttribute("action") || "";
        if (currentAct.indexOf("/cart/add") !== -1) return;

        form.action = cleanCode
          ? "/cart?discount=" + encodeURIComponent(cleanCode)
          : "/cart";
        var hidden = form.querySelector('input[name="discount"]');
        if (cleanCode) {
          if (!hidden) {
            hidden = document.createElement("input");
            hidden.type = "hidden";
            hidden.name = "discount";
            form.appendChild(hidden);
          }
          hidden.value = cleanCode;
        } else if (hidden) {
          hidden.remove();
        }
      } catch (e) {}
    });
  }

  function getItemLinePriceInRupees(item) {
    if (!item) return 0;
    var raw = 0;
    if (typeof item.original_line_price === "number") {
      raw = item.original_line_price;
    } else if (typeof item.final_line_price === "number") {
      raw = item.final_line_price;
    } else if (typeof item.line_price === "number") {
      raw = item.line_price;
    } else if (typeof item.price === "number") {
      if (
        typeof item.quantity === "number" &&
        item.quantity > 1 &&
        item.final_line_price == null &&
        item.line_price == null &&
        item.original_line_price == null
      ) {
        raw = item.price * item.quantity;
      } else {
        raw = item.price;
      }
    } else if (typeof item.price === "string") {
      raw = parseFloat(item.price) || 0;
    }
    return Math.round(raw / 100);
  }

  function getCartItems() {
    if (
      window.cart &&
      Array.isArray(window.cart.items) &&
      window.cart.items.length > 0
    ) {
      return window.cart.items;
    }
    if (_cachedCartItems && _cachedCartItems.length > 0) {
      return _cachedCartItems;
    }
    var target = document.querySelector('[data-global-coupons-target="cart"]');
    if (target) {
      try {
        var dataEl = document.getElementById("GlobalCartItemsData");
        var raw = (dataEl && dataEl.textContent) || "[]";
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed;
        }
      } catch (e) {
        console.warn("[global-coupons] data-gc-cart-items parse error", e);
      }
    }
    return [];
  }

  function calculateEligibleSubtotal(coupon, cartTotalRupees, items) {
    var cartTotal = Math.round(Number(cartTotalRupees) || 0);
    if (!coupon || cartTotal <= 0) return 0;

    var elig = (coupon.eligibility || "all").toLowerCase();

    // eligibility "all" -> the whole cart counts
    if (elig === "all") {
      return cartTotal;
    }

    var cartItems =
      Array.isArray(items) && items.length > 0 ? items : getCartItems();
    if (!cartItems || cartItems.length === 0) {
      return cartTotal;
    }

    var eligibleSubtotal = 0;

    // eligibility "product" -> sum lines where item.handle === target_product
    if (elig === "product") {
      var targetProd = (
        typeof coupon.target_product === "object" && coupon.target_product
          ? coupon.target_product.handle
          : coupon.target_product || ""
      )
        .trim()
        .toLowerCase();

      if (!targetProd) return cartTotal;

      for (var i = 0; i < cartItems.length; i++) {
        var it = cartItems[i];
        var itHandle = (it.handle || it.product_handle || "")
          .trim()
          .toLowerCase();
        if (itHandle === targetProd) {
          eligibleSubtotal += getItemLinePriceInRupees(it);
        }
      }
      return Math.min(eligibleSubtotal, cartTotal);
    }

    // eligibility "collection" -> sum lines belonging to target_collection
    if (elig === "collection") {
      var targetCol = (
        typeof coupon.target_collection === "object" && coupon.target_collection
          ? coupon.target_collection.handle
          : coupon.target_collection || ""
      )
        .trim()
        .toLowerCase();

      if (!targetCol) return cartTotal;

      for (var j = 0; j < cartItems.length; j++) {
        var item = cartItems[j];
        var isMatch = false;

        // Match on item.collections
        if (item.collections) {
          var colList = csv(item.collections).map(function (c) {
            return c.toLowerCase();
          });
          if (colList.indexOf(targetCol) !== -1) {
            isMatch = true;
          }
        }

        // Match on item.url containing '/collections/' + targetCol
        if (!isMatch && item.url) {
          if (
            item.url.toLowerCase().indexOf("/collections/" + targetCol) !== -1
          ) {
            isMatch = true;
          }
        }

        if (isMatch) {
          eligibleSubtotal += getItemLinePriceInRupees(item);
        }
      }
      return Math.min(eligibleSubtotal, cartTotal);
    }

    return cartTotal;
  }

  function updateCartSummaryWithCoupon(
    appliedCoupon,
    subtotalRupees,
    cartItems,
  ) {
    var subtotalEl = document.querySelector("[data-cart-subtotal]");
    var discountRow = document.querySelector("[data-cart-discount-row]");
    var discountEl = document.querySelector("[data-cart-discount]");
    var totalEl = document.querySelector("[data-cart-total]");

    var subRupees =
      typeof subtotalRupees === "number"
        ? subtotalRupees
        : getCartSubtotalInRupees();

    var discountRupees = 0;
    if (appliedCoupon && subRupees > 0) {
      var eligibleSubtotal = calculateEligibleSubtotal(
        appliedCoupon,
        subRupees,
        cartItems,
      );

      if (eligibleSubtotal > 0) {
        var type = (appliedCoupon.type || "flat").toLowerCase();
        var val = parseFloat(appliedCoupon.value) || 0;
        var cap = parseFloat(appliedCoupon.max) || 0;

        if (type === "percentage") {
          discountRupees = Math.round(eligibleSubtotal * (val / 100));
          if (cap > 0 && discountRupees > cap) {
            discountRupees = Math.round(cap);
          }
        } else {
          discountRupees = Math.round(val);
        }
        // The discount can never exceed the eligible subtotal
        discountRupees = Math.min(discountRupees, eligibleSubtotal);
      }
    }

    if (discountRow && discountEl) {
      if (discountRupees > 0) {
        discountEl.textContent = "\u2212 " + formatRupees(discountRupees);
        discountRow.hidden = false;
        discountRow.removeAttribute("hidden");
      } else {
        discountEl.textContent = "\u2212 " + formatRupees(0);
        discountRow.hidden = true;
        discountRow.setAttribute("hidden", "");
      }
    }

    if (totalEl) {
      var finalRupees = Math.max(0, subRupees - discountRupees);
      totalEl.textContent = formatRupees(finalRupees);
    }
  }

  /* Cart renderer (pure rupees) */

  function renderCart(root, coupons) {
    _cachedCoupons = coupons || [];

    var items = [];
    try {
      var dataEl = document.getElementById("GlobalCartItemsData");
      var raw = (dataEl && dataEl.textContent) || "[]";
      items = JSON.parse(raw);
    } catch (e) {
      console.warn("[global-coupons] data-gc-cart-items parse error", e);
      items = [];
    }

    if (
      window.cart &&
      Array.isArray(window.cart.items) &&
      window.cart.items.length > 0
    ) {
      items = window.cart.items;
    }
    _cachedCartItems = items;

    var cartTotalRupees = getCartSubtotalInRupees();

    var ctx = {
      kind: "cart",
      price: cartTotalRupees,
      items: items,
    };

    var visible = [];
    for (var i = 0; i < coupons.length; i++) {
      var c = coupons[i];
      if (c.active && c.code && c.title && eligibleFor(c, ctx)) {
        visible.push(c);
      }
    }

    var appliedCode = isCouponApplied ? getAppliedCouponCode() : "";
    var currentAppliedCoupon = null;

    if (isCouponApplied && appliedCode) {
      for (var j = 0; j < visible.length; j++) {
        if (
          visible[j].code &&
          visible[j].code.toUpperCase() === appliedCode.toUpperCase()
        ) {
          var checkMin = parseRupees(visible[j].min_purchase);
          if (checkMin > 0 && cartTotalRupees < checkMin) {
            // Cart subtotal dropped below threshold; revoke applied coupon
            setAppliedCouponCode("");
            appliedCode = "";
          } else {
            currentAppliedCoupon = visible[j];
          }
          break;
        }
      }
      appliedCouponObj = currentAppliedCoupon;
    } else {
      appliedCouponObj = null;
      appliedCode = "";
    }

    updateCartSummaryWithCoupon(appliedCouponObj, cartTotalRupees, items);
    syncCheckoutWithDiscount(appliedCouponObj ? appliedCouponObj.code : "");

    if (visible.length === 0) {
      if (root.tagName === "DETAILS") {
        var placeholder = document.createElement("div");
        placeholder.setAttribute("data-global-coupons-target", "cart");
        placeholder.setAttribute(
          "data-gc-cart-total-rupees",
          String(cartTotalRupees),
        );
        placeholder.setAttribute("data-gc-cart-items", JSON.stringify(items));
        if (root.parentNode) root.parentNode.replaceChild(placeholder, root);
      } else {
        root.innerHTML = "";
      }
      return;
    }

    var rows = "";
    for (var k = 0; k < visible.length; k++) {
      var coupon = visible[k];
      var minPurchaseRupees = parseRupees(coupon.min_purchase);
      var shortfallRupees = minPurchaseRupees - cartTotalRupees;
      var hasShortfall = minPurchaseRupees > 0 && shortfallRupees > 0;

      var isApplied = Boolean(
        appliedCode &&
        coupon.code &&
        coupon.code.toUpperCase() === appliedCode.toUpperCase(),
      );

      var btnText = isApplied ? "Remove" : "Apply";
      var btnClasses =
        "cart-coupon__apply" + (isApplied ? " is-applied is-active" : "");
      var btnAction = isApplied ? "remove" : "apply";
      var btnDisabledAttr =
        !isApplied && hasShortfall ? ' disabled aria-disabled="true"' : "";

      var shortfallHtml =
        !isApplied && hasShortfall
          ? '<div class="cart-coupon__shortfall" style="font-family:var(--font-body);font-size:11px;color:#8c734b;margin-top:4px;font-weight:500;line-height:1.2;">Add Rs. ' +
            shortfallRupees.toLocaleString("en-IN") +
            " more to apply</div>"
          : "";

      rows +=
        "" +
        '<div class="cart-coupon" data-cart-coupon-row data-coupon-context="cart">' +
        '<div class="cart-coupon__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24">' +
        '<polyline points="20 12 20 22 4 22 4 12"/>' +
        '<rect x="2" y="7" width="20" height="5"/>' +
        '<line x1="12" y1="22" x2="12" y2="7"/>' +
        '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
        '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
        "</svg>" +
        "</div>" +
        '<div class="cart-coupon__body">' +
        '<div class="cart-coupon__title">' +
        escapeHtml(coupon.title) +
        "</div>" +
        '<div class="cart-coupon__code">' +
        '<span class="cart-coupon__code-label">Code</span>' +
        '<span class="cart-coupon__code-value" data-cart-coupon-code>' +
        escapeHtml(coupon.code) +
        "</span>" +
        "</div>" +
        shortfallHtml +
        "</div>" +
        '<button type="button" class="' +
        btnClasses +
        '" data-cart-coupon-apply' +
        ' data-action="' +
        btnAction +
        '"' +
        ' data-code="' +
        escapeHtml(coupon.code) +
        '"' +
        ' data-type="' +
        escapeHtml(coupon.type || "flat") +
        '"' +
        ' data-value="' +
        escapeHtml(String(coupon.value || 0)) +
        '"' +
        ' data-max="' +
        escapeHtml(String(coupon.max || 0)) +
        '"' +
        ' data-min-purchase="' +
        escapeHtml(String(minPurchaseRupees)) +
        '"' +
        ' data-eligibility="' +
        escapeHtml(coupon.eligibility || "all") +
        '"' +
        ' data-target-collection="' +
        escapeHtml(
          String(
            (typeof coupon.target_collection === "object" &&
            coupon.target_collection
              ? coupon.target_collection.handle
              : coupon.target_collection) || "",
          ),
        ) +
        '"' +
        ' data-target-product="' +
        escapeHtml(
          String(
            (typeof coupon.target_product === "object" && coupon.target_product
              ? coupon.target_product.handle
              : coupon.target_product) || "",
          ),
        ) +
        '"' +
        btnDisabledAttr +
        ">" +
        btnText +
        "</button>" +
        "</div>";
    }

    var wasOpen = root.tagName === "DETAILS" ? root.open : false;

    var styleBlock =
      "<style>" +
      ".cart-coupon__apply.is-applied{background:var(--color-burgundy,#5c0a1e)!important;color:var(--color-gold,#c5a45a)!important;border-color:var(--color-burgundy,#5c0a1e)!important;border-style:solid!important;}" +
      ".cart-coupon__apply[disabled]{opacity:0.5;cursor:not-allowed!important;pointer-events:none;}" +
      "</style>";

    var accordion =
      "" +
      styleBlock +
      '<details class="cart-drawer__coupons" ' +
      (wasOpen ? "open " : "") +
      'data-global-coupons-target="cart" data-gc-cart-total-rupees="' +
      cartTotalRupees +
      '" data-cart-coupons aria-label="Available coupons">' +
      '<summary class="cart-coupons__summary" data-cart-coupon-toggle>' +
      '<span class="cart-coupons__summary-left">' +
      '<span class="cart-coupons__gift" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24">' +
      '<polyline points="20 12 20 22 4 22 4 12"/>' +
      '<rect x="2" y="7" width="20" height="5"/>' +
      '<line x1="12" y1="22" x2="12" y2="7"/>' +
      '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
      '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
      "</svg>" +
      "</span>" +
      '<span class="cart-coupons__label">' +
      '<span class="cart-coupons__label-count" data-cart-coupon-count>' +
      visible.length +
      "</span>" +
      " Coupons Available" +
      "</span>" +
      "</span>" +
      '<span class="cart-coupons__chevron" aria-hidden="true">' +
      '<span class="cart-coupons__chevron-label">View</span>' +
      '<svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>' +
      "</span>" +
      "</summary>" +
      '<div class="cart-coupons__panel">' +
      rows +
      "</div>" +
      "</details>";

    root.outerHTML = accordion;
    wireCartApplyButtons();
  }

  function wireCartApplyButtons() {
    if (window.__cartApplyWired) return;
    window.__cartApplyWired = true;

    document.addEventListener(
      "click",
      function (e) {
        var btn =
          e.target.closest && e.target.closest("[data-cart-coupon-apply]");
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        if (
          btn.hasAttribute("disabled") ||
          btn.disabled ||
          btn.getAttribute("aria-disabled") === "true"
        ) {
          return;
        }

        var action = btn.getAttribute("data-action") || "apply";
        var code = (btn.getAttribute("data-code") || "").trim();

        if (action === "remove" || btn.classList.contains("is-applied")) {
          // Remove coupon
          setAppliedCouponCode("");
          syncCheckoutWithDiscount("");
        } else {
          // Apply coupon: recheck min_purchase against the live cart total
          var cartTotalRupees = getCartSubtotalInRupees();
          var rawMin = btn.getAttribute("data-min-purchase");
          var minRupees = parseRupees(rawMin);

          if (minRupees > 0 && cartTotalRupees < minRupees) {
            console.warn(
              "[global-coupons] Cart total Rs. " +
                cartTotalRupees +
                " is below min purchase Rs. " +
                minRupees,
            );
            return;
          }

          setAppliedCouponCode(code);
          syncCheckoutWithDiscount(code);

          var couponObj = null;
          for (var i = 0; i < _cachedCoupons.length; i++) {
            if (
              _cachedCoupons[i].code &&
              _cachedCoupons[i].code.toUpperCase() === code.toUpperCase()
            ) {
              couponObj = _cachedCoupons[i];
              break;
            }
          }
          if (!couponObj) {
            couponObj = {
              code: code,
              type: btn.getAttribute("data-type") || "flat",
              value: parseFloat(btn.getAttribute("data-value")) || 0,
              max: parseFloat(btn.getAttribute("data-max")) || 0,
              min_purchase: minRupees,
              eligibility: btn.getAttribute("data-eligibility") || "all",
              target_collection:
                btn.getAttribute("data-target-collection") || "",
              target_product: btn.getAttribute("data-target-product") || "",
            };
          }
          appliedCouponObj = couponObj;
        }

        // One re-render pass keeps the button and summary in sync (avoids double deduction)
        var cartRoot = document.querySelector(
          '[data-global-coupons-target="cart"]',
        );
        if (cartRoot) {
          renderCart(cartRoot, _cachedCoupons);
        } else {
          updateCartSummaryWithCoupon(
            isCouponApplied ? appliedCouponObj : null,
            getCartSubtotalInRupees(),
            _cachedCartItems,
          );
        }
      },
      true,
    );

    // Intercept clicks on Checkout buttons/links so discount is guaranteed to be applied
    document.addEventListener(
      "click",
      function (e) {
        var checkoutTarget =
          e.target.closest &&
          e.target.closest(
            '[data-cart-checkout], a[href*="/checkout"], .cart__checkout-button, button[name="checkout"]',
          );
        if (!checkoutTarget) return;
        if (
          checkoutTarget.getAttribute("aria-disabled") === "true" ||
          checkoutTarget.classList.contains("is-disabled")
        ) {
          return;
        }

        var code = getAppliedCouponCode();
        if (!code) return;

        syncCheckoutWithDiscount(code);

        if (checkoutTarget.tagName === "A") {
          e.preventDefault();
          window.location.href =
            "/checkout?discount=" + encodeURIComponent(code);
        } else if (
          checkoutTarget.tagName === "BUTTON" ||
          checkoutTarget.tagName === "INPUT"
        ) {
          var form = checkoutTarget.closest("form");
          if (form) {
            var hidden = form.querySelector('input[name="discount"]');
            if (!hidden) {
              hidden = document.createElement("input");
              hidden.type = "hidden";
              hidden.name = "discount";
              form.appendChild(hidden);
            }
            hidden.value = code;
          } else {
            e.preventDefault();
            window.location.href =
              "/checkout?discount=" + encodeURIComponent(code);
          }
        }
      },
      true,
    );
  }

  /* Bootstrap */

  function bootstrap() {
    try {
      var pdpRoot = document.querySelector(
        '[data-global-coupons-target="product"]',
      );
      var cartRoot = document.querySelector(
        '[data-global-coupons-target="cart"]',
      );

      var dataEl = document.getElementById("GlobalCouponData");
      if (!dataEl) {
        if (pdpRoot) pdpRoot.innerHTML = "";
        if (cartRoot) cartRoot.innerHTML = "";
        return;
      }

      var text = (dataEl.textContent || "").trim();
      if (!text || text === "[]") {
        if (pdpRoot) pdpRoot.innerHTML = "";
        if (cartRoot) cartRoot.innerHTML = "";
        return;
      }

      var coupons;
      try {
        coupons = JSON.parse(text);
      } catch (e) {
        console.warn(
          "[global-coupons] JSON.parse failed for #GlobalCouponData",
          e,
        );
        if (pdpRoot) pdpRoot.innerHTML = "";
        if (cartRoot) cartRoot.innerHTML = "";
        return;
      }
      if (!Array.isArray(coupons)) {
        if (pdpRoot) pdpRoot.innerHTML = "";
        if (cartRoot) cartRoot.innerHTML = "";
        return;
      }

      _cachedCoupons = coupons;
      if (pdpRoot) renderPdp(pdpRoot, coupons);
      if (cartRoot) renderCart(cartRoot, coupons);

      // Initialize checkout links and apply listeners
      syncCheckoutWithDiscount(getAppliedCouponCode());
      wireCartApplyButtons();
    } catch (err) {
      console.warn("[global-coupons] bootstrap error", err);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener("shopify:section:load", bootstrap);
  document.addEventListener("cart:updated", bootstrap);
})();
